export const pubMediaLibraryTypes = {
  PUB_MEDIA_LIBRARY_ONCHANGE: "PUB_MEDIA_LIBRARY_ONCHANGE",
  SELECTED_PUB_ML_CATEGORY: "SELECTED_PUB_ML_CATEGORY",
  SELECTED_PUB_PML_FILTER: "SELECTED_PUB_PML_FILTER",
  CLEAR_PML_FILTER: "CLEAR_PML_FILTER"
};
